import classNames from "classnames";

import styles from "./LabeledInfo.module.css";

export default function LabeledInfo(props: {
  label: string;
  value: string;
  orientation?: "horizontal" | "vertical";
}) {
  return (
    <div
      className={classNames(
        props.orientation === "vertical" ? styles.col : styles.row,
        styles.labeledInfo,
      )}
    >
      <span className={styles.label}>{props.label}</span>
      <span className={styles.value}>{props.value}</span>
    </div>
  );
}
